
import {GoingUtils,AssertUtils,StorageUtils} from "goingutils";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _getFontCss(treeId, treeNode) {
    return GoingUtils.parseBoolean(treeNode.highlight) ? { color: "#A60000", "font-weight": "bold" } : { color: "#333", "font-weight": "normal" };
}

class zTreeObject {

    constructor(_ref) {
        var treeId = _ref.treeId,
            asyncUrl = _ref.asyncUrl,
            initUrl = _ref.initUrl;


        _classCallCheck(this, zTreeObject);


        var obj = this;
        obj.onClick = null;

        var setting = {
            icons:_ref.icons,
            data: {
                key: {
                    title: "t"
                },
                simpleData: {
                    enable: true
                }
            },
            callback: {
                //异步查询成功
                onAsyncSuccess:(event, treeId, treeNode, msg)=>{
                    if(obj.openRootNode){
                        let treeObj = $.fn.zTree.getZTreeObj(this.treeId);
                        let nodes=treeObj.getNodes();
                        treeObj.expandNode(nodes[0], true, null, null, true);
                    }
                    if (AssertUtils.isNotNull(obj["onAsyncSuccess"])) {
                        obj["onAsyncSuccess"](event, treeId, treeNode);
                    }
                },
                //双击
                onDblClick: function onClick(event, treeId, treeNode, clickFlag) {
                    if (AssertUtils.isNotNull(obj["onDblClick"])) {
                        obj["onDblClick"](treeNode["id"], obj, treeNode, clickFlag, event);
                    }
                },
                beforeClick: obj.beforeClick,
                //单击
                onClick: function onClick(event, treeId, treeNode, clickFlag) {
                    if (AssertUtils.isNotNull(obj["onClick"])) {
                        obj["onClick"](treeNode["id"], obj, treeNode, clickFlag, event);
                    }
                }
            },
            view: {
                fontCss: _getFontCss
            }
        };
        //如果异步参数不为空
        if (AssertUtils.isNotEmpty(initUrl)) {
            setting = obj.setAsyncPrototype(setting, initUrl, asyncUrl);
        }
        obj.openNode=_ref.openNode;
        obj.openRootNode=_ref.openRootNode;
        obj.initUrl = initUrl;
        obj.asyncUrl = asyncUrl;
        obj.treeId = treeId;
        obj.setting = setting;
    }
}

//通过action来刷新树解构
zTreeObject.prototype.setAsyncPrototype = function (setting, initUrl, asyncUrl) {
    let obj = this;
    obj.filter = function (treeId, parentNode, childNodes) {
        let newBackData = [];
        if(childNodes&&childNodes.data){
            childNodes=childNodes.data;
        }
        childNodes.forEach(function (jsonItem) {
            jsonItem["pId"]=String(jsonItem["parentId"]);
            newBackData.push(jsonItem);
        });
        obj._treeData=newBackData;
        if (!newBackData) return null;

        for (let i = 0, l = newBackData.length; i < l; i++) {
            if(obj.openNode===true){
                newBackData[i].open = true;
            }else{
                newBackData[i].open = false;
            }
        }
        return newBackData;
    };

    //如果异步参数不为空
    var getAsyncUrl = function getAsyncUrl(treeId, treeNode) {
        if (!!treeNode && !!treeNode.id) {
            return asyncUrl + "/" + treeNode.id;
        } else {
            return initUrl;
        }
    };


    const token = StorageUtils.getSessionItem("sessionId");

    setting = $.extend({}, setting, {
        async: {
            enable: true,
            url: getAsyncUrl,
            headers:{
                Accept: "application/json",
                // "Content-Type": "multipart/form-data",
                "Content-Type": "application/json; charset=utf-8",
                "Blade-Auth": `bearer ${token}`,
                Authorization: `Basic c2FiZXI6c2FiZXJfc2VjcmV0`
            },
            autoParam: ["id", "name=n", "level=lv"],
            otherParam: { "sessionId": StorageUtils.getSessionItem("sessionId") },
            dataFilter: obj.filter
        }
    });
    return setting;
};
//获取ztree对象
zTreeObject.prototype.getZTreeObj = function () {
    this.treeObj = $.fn.zTree.getZTreeObj(this.treeId);
    return this.treeObj;
};
zTreeObject.prototype.destructor = function () {
    this.initUrl = null;
    this.asyncUrl = null;
    this.treeId = null;
    this.setting = null;
    this.data = null;
    this.treeObj = null;
    this._treeData=null;
};
zTreeObject.prototype.initAsyncTree = function () {
    this.AsyncFlag = true;
    this.treeObj = $.fn.zTree.init($("#" + this.treeId), this.setting);
};
//通过action来刷新树解构
zTreeObject.prototype.flushTreeByAction = function (action, vueObj) {
    var orgTreeObj = this;
    //缓存查询
    orgTreeObj["action"] = action;
    //加载数据
    vueObj.$store.dispatch(action, function (backDs) {
        backDs[0]["open"] = true;
        //将结果返回成 树要求的格式
        orgTreeObj.flushTreeByData(backDs);
    });
};
//通过data来初始化树对象
zTreeObject.prototype.flushTreeByData = function (zNodes) {
    this.data = zNodes;
    this.treeObj = $.fn.zTree.init($("#" + this.treeId), this.setting, zNodes);
};
//获取当前选中结点的id
zTreeObject.prototype.getSelectedItemId = function (zNodes) {
    var nodes = this.treeObj.getSelectedNodes();
    if (nodes != null && nodes[0] != null) {
        return nodes[0]["id"];
    } else {
        return null;
    }
};
//获取当前选择的结点的text
zTreeObject.prototype.getSelectedItemText = function (zNodes) {
    var nodes = this.treeObj.getSelectedNodes();
    return nodes[0]["name"];
};
//通过data来初始化树对象
zTreeObject.prototype.attachEvent = function (clickEventName, fun) {
    this[clickEventName] = fun;
};
//通过节点id 获取节点的中文信息
zTreeObject.prototype.getItemText = function (nodeId) {
    var node = this.treeObj.getNodesByParam("id", nodeId);
    if (node.length > 0) {
        return node[0]["name"];
    }
};
/**
 * 选中节点
 * @param nodeId
 * @param eventFlag
 * @returns {*}
 */
zTreeObject.prototype.selectItem = function (nodeId, eventFlag) {
    var node = this.treeObj.getNodesByParam("id", nodeId);
    if (node.length > 0) {
        this.treeObj.selectNode(node[0]);
    }
};

//通过节点id 获取父节点的id
zTreeObject.prototype.getParentId = function (nodeId) {
    var node = this.treeObj.getNodesByParam("id", nodeId);
    if (node.length > 0) {
        return node[0]["pId"];
    }
};
//通过data来初始化树对象
zTreeObject.prototype.reloadData = function ({
                                                 sleNodeFlag,
                                                 backFun,
                                                 selbackFlag=false
                                             }) {
    //如果选中标志为true 则获取树当前选择的结点id
    var nodes = [];
    if (sleNodeFlag) {
        nodes = this.treeObj.getSelectedNodes();
    }
    var treeObj = this.treeObj;
    this.treeObj.reAsyncChildNodes(null, "refresh", null, function () {
        if (sleNodeFlag && nodes.length > 0) {
            //根据id找到以前的节点 然后选中当前节点
            var nodesNew = treeObj.getNodesByParam("id", nodes[0]["id"]);
            if (nodesNew.length > 0) {
                treeObj.selectNode(nodesNew[0]);
                treeObj.expandNode(nodesNew[0], true, null, null, selbackFlag);
            }
            backFun&&backFun();
        }
    });
    return this;
};

export default zTreeObject;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/comCtl/zTreeObject.js